import { ApiState } from 'infrastructure/api';
import type { PaymentMethodsRepositoryState } from './types';

export const stateFactory: () => PaymentMethodsRepositoryState = () => ({
    apiState: ApiState.Idle
});

export default stateFactory;
